<template>
  <div @click="handleDetail" class="answer-card">
    <div v-if="question" class="answer-des">
      <Avatar :user="question.user" size="def" />

      <div class="answer-description">
        <div class="answer-dot">
          <span class="answer-user">{{ question.user.name }}</span>
          <span class="answer-type">{{ answerTypeText }}</span>
          <span class="answer-title">{{ subject }}</span>
        </div>
        <div class="answer-time">{{ time | time2tips }}</div>
      </div>
    </div>
    <div class="answer-content">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
      default: () => null
    },
    type: String
  },
  computed: {
    answerTypeText() {
      return {
        invite: "提出了",
        new_answer: "回答了"
      }[this.type];
    },
    content() {
      return this.question.text_body;
    },
    time() {
      return this.question.created_at;
    },
    subject() {
      if (this.type === "new_answer") {
        const question = this.question.question;
        return question.subject;
      }
      return this.question.subject;
    }
  },
  methods: {
    handleDetail() {
      const id =
        this.type === "new_answer"
          ? this.question.question_id
          : this.question.id;
      this.$router.push({
        path: `/questions/${id}`
      });
    }
  }
};
</script>

<style lang="less" scoped>
.answer-des {
  display: flex;
  max-width: 100%;
  font-size: 26px;
  .answer-type {
    margin: 0 12px;
    color: #999;
    font-size: 26px;
  }
  .answer-description {
    margin-left: 16px;
    color: #3283a2;
    flex: 1;
  }
  .answer-dot {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    word-break: break-all;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
  }
  .answer-time {
    color: #b2b2b2;
    font-size: 22px;
    margin-top: 4px;
  }
}
.answer-content {
  margin-top: 23px;
  font-size: 28px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}
</style>
